import React from 'react'
import Content from 'blocks.app/content/content'
import Catalog from 'blocks.app/catalog/catalog'
import translate from 'core/translate'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import { SURVEY_CATALOG_CONFIG, SURVEY_CATALOG_TITLE_KEY } from './InstancesCatalogSurvey-types'

const InstancesCatalogSurveyComponent = () => {
    return (
        <Content title={translate(SURVEY_CATALOG_TITLE_KEY)}>
            <Catalog
                type={SURVEY_CATALOG_CONFIG.type}
                treeView={SURVEY_CATALOG_CONFIG.treeView}
                additionalData={{}}
                fixedHeader={SURVEY_CATALOG_CONFIG.fixedHeader}
                isExistRightToolbar={SURVEY_CATALOG_CONFIG.isExistRightToolbar}
                hideHeader={SURVEY_CATALOG_CONFIG.hideHeader}
            />
        </Content>
    )
}

export const InstancesCatalogSurvey = checkAvailableModule('instancesCatalog/surveyCatalog')
    ? InstancesCatalogSurveyComponent
    : null
